/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Streamerreport_Discover_Body1Inputs */

const ja_playdata_streamerreport_discover_body1 = /** @type {(inputs: Playdata_Streamerreport_Discover_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期間やゲーム、キーワードなどを検索・フィルタリングすることで、現在注目を浴びているストリーマーを見つけ出すことが可能なツールを開発しました。新進気鋭のストリーマーや今後のトレンドを発見するための強力なアシストとなります。`)
};

const en_playdata_streamerreport_discover_body1 = /** @type {(inputs: Playdata_Streamerreport_Discover_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We built a tool that lets you search and filter by period, game or keyword to surface the streamers drawing attention right now. It is a strong assist for finding up-and-coming streamers and spotting the next trend.`)
};

/**
* | output |
* | --- |
* | "We built a tool that lets you search and filter by period, game or keyword to surface the streamers drawing attention right now. It is a strong assist for fi..." |
*
* @param {Playdata_Streamerreport_Discover_Body1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_streamerreport_discover_body1 = /** @type {((inputs?: Playdata_Streamerreport_Discover_Body1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Streamerreport_Discover_Body1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_streamerreport_discover_body1(inputs)
	return en_playdata_streamerreport_discover_body1(inputs)
});
export { playdata_streamerreport_discover_body1 as "playdata_streamerReport_discover_body" }